import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPolandFlagIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "flag-icon-css-pl",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 512 512",
	style: { enableBackground: "new 0 0 512 512" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.poland-flag-st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E9E8E7;}\n	.poland-flag-st1{fill-rule:evenodd;clip-rule:evenodd;fill:#D4213D;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "poland-flag-st0",
		d: "M512,512H0V0h512V512z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "poland-flag-st1",
		d: "M512,512H0V256h512V512z"
	})] })]
});
export default SvgPolandFlagIcon;
